import { render, staticRenderFns } from "./ChooseImage.vue?vue&type=template&id=792d96d7&scoped=true&"
import script from "./ChooseImage.vue?vue&type=script&lang=js&"
export * from "./ChooseImage.vue?vue&type=script&lang=js&"
import style0 from "./ChooseImage.vue?vue&type=style&index=0&id=792d96d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d96d7",
  null
  
)

export default component.exports